import { useStaffMembers } from 'app/scenes/ui-extension/JournalSummarySelection/staff-members';
import React from 'react';

export const AssigneeName: React.FC<{ uid: string }> = ({ uid }) => {
  const staffMembers = useStaffMembers();
  const staffMember = staffMembers.find(staffMember => staffMember.uid === uid);
  return <>{staffMember ? `${staffMember.firstName} ${staffMember.lastName}` : `Unknown user: ${uid}`}</>;
};
